<template>
  <div>
    <banner :title="'公司简介'"></banner>
    <div class="list">
      <div class="l-title">
        <span>
          <b>公司简介</b>
        </span>
      </div>
      <div class="wrap single">
        <p>
          　　河南一六八线缆有限公司是河南省生产电线电缆的优良企业，公司生产中心位于武陟县詹店工业园区，紧邻S86原焦高速、G107京深线，距离省会郑州仅30公里，交通便利。占地2.1万多平方米，按照花园式标准化厂房建设，环境优美；拥有多套生产设备和检测设备。
        </p>
        <p>
          　　公司拥有大批品德高尚、技术精湛、勤学苦干的管理团队和技术人才。
        </p>
        <p>
          　　科研集体、优良的生产团队、严格的质量把控、销售及售后服务综合管理体系，使我们提供的的产品质量可靠运行良好，获得广大客户的热烈好评。公司先后获得重合同守信用证书、诚信经营示范单位证书、质量服务诚信单位证书、AAA
          级企业信用证书、AAA
          级企业资信证书、河南省电工行业协会常务理事单位和中国电线电缆行业名优企业。
        </p>
        <p>
          　　公司通过实施自动化、国际化战略，优化调整产业结构，不断提高自身产品的质量和效益，努力把公司建设成为管理、技术密集的国内与国际接轨的电缆行业标杆。公司先后通过了IS09001质量管理体系认证、ISO14001环境管理体系认证、OHSAS18001职业健康安全管理体系认证，为广大顾客提供优良的产品和全方面的服务。
        </p>
        <p><br /></p>
      </div>
    </div>
  </div>
</template>

<script>
import banner from "../components/banner.vue";
export default {
  components: {
    banner,
  },
};
</script>

<style lang="less" scoped>
.l-title b:after {
  content: "";
  width: 100px;
  height: 3px;
  background: @primaryColor;
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  bottom: 0;
}
.list .warp p {
  text-align: left;
}
</style>
